import { ArrowLeftOutlined } from '@ant-design/icons'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import './fixed.scss'

export interface IPropsFixedNavBar {
    title?: string,
    styleNavBar?: React.CSSProperties,
    children?: React.ReactNode
}
export const FixedNavBar = ({ title, styleNavBar, children }: IPropsFixedNavBar) => {
    const navigate = useNavigate()
    return (
        <div className="a-fixedNav" style={styleNavBar} >
            <ArrowLeftOutlined className="a-fixedNav__right" onClick={() => navigate(-1)} />
            {
                title && <h1 className="a-fixedNav__title">{title}</h1>
            }
            {
                children
            }
        </div>
    )
}
